import { Routes } from '@angular/router';
import { NotFoundComponent } from './shared/pages/not-found/not-found.component';
import { RootRedirectGuard } from './core/guards/root-redirect.guard';
import { AuthGuard } from './core/guards/auth.guard';
import {
  matchAdmin,
  matchCompany,
  matchConcierge,
  matchExpert,
  matchSales,
} from './core/guards/role-match.guard';
import { legacyRolePrefixRedirect } from './core/guards/legacy-role-prefix-redirect.guard';

const LEGACY_ROLE_PREFIXES = [
  'admin',
  'sales',
  'concierge',
  'company',
  'expert',
] as const;

const LEGACY_PREFIX_REDIRECTS: Routes = LEGACY_ROLE_PREFIXES.map((prefix) => ({
  path: prefix,
  children: [
    {
      path: '**',
      canActivate: [legacyRolePrefixRedirect(prefix)],
      component: NotFoundComponent,
    },
  ],
}));

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'login',
        redirectTo: 'auth/login',
        pathMatch: 'full',
      },
      {
        path: 'auth',
        loadChildren: () =>
          import('./auth/auth.routes').then((m) => m.AUTH_ROUTES),
      },
      {
        path: 'public',
        loadChildren: () =>
          import('./public/public.routes').then((m) => m.PUBLIC_ROUTES),
      },
      {
        path: 'access-denied',
        loadComponent: () =>
          import('./shared/pages/access-denied/access-denied.component').then(
            (m) => m.AccessDeniedComponent
          ),
      },
      ...LEGACY_PREFIX_REDIRECTS,
      {
        path: '',
        canMatch: [matchAdmin],
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./routing/admin.routes').then((m) => m.ADMIN_ROUTES),
      },
      {
        path: '',
        canMatch: [matchSales],
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./routing/sales.routes').then((m) => m.SALES_ROUTES),
      },
      {
        path: '',
        canMatch: [matchConcierge],
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./routing/concierge.routes').then(
            (m) => m.CONCIERGE_ROUTES
          ),
      },
      {
        path: '',
        canMatch: [matchCompany],
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./routing/company.routes').then((m) => m.COMPANY_ROUTES),
      },
      {
        path: '',
        canMatch: [matchExpert],
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./routing/expert.routes').then((m) => m.EXPERT_ROUTES),
      },
      {
        path: 'signup/expert',
        redirectTo: 'auth/signup/expert',
        pathMatch: 'full',
      },
      {
        path: '',
        canActivate: [RootRedirectGuard],
        component: NotFoundComponent,
      },
      {
        path: '**',
        component: NotFoundComponent,
      },
    ],
  },
];
